import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppLoadingScreen from '@components/AppLoadingScreen';

/** Safety cap so the overlay never sticks on slow route mounts. */
const ROUTE_LOADER_MAX_MS = 320;

/**
 * Brief full-page loader on route changes. Hides as soon as the next paint
 * completes (fast navigations) or after a short max duration (slow mounts).
 */
const NavigationLoadingOverlay: React.FC = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    setVisible(true);
    let hidden = false;

    const hide = () => {
      if (hidden) {
        return;
      }
      hidden = true;
      setVisible(false);
    };

    const maxTimer = window.setTimeout(hide, ROUTE_LOADER_MAX_MS);
    const rafId = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(hide);
    });

    return () => {
      window.clearTimeout(maxTimer);
      window.cancelAnimationFrame(rafId);
      hide();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- navigation identity
  }, [location.pathname, location.key]);

  if (!visible) {
    return null;
  }

  return (
    <AppLoadingScreen
      variant="overlay"
      context="route"
    />
  );
};

export default NavigationLoadingOverlay;
